﻿export function getHeightPlusMargins(element: HTMLElement | undefined | null) {
    if (element) {
        const computedStyle = window.getComputedStyle(element);
        const marginTop = parseInt(computedStyle.marginTop, 10);
        const marginBottom = parseInt(computedStyle.marginBottom, 10);
        return element.offsetHeight + marginTop + marginBottom;
    }
    return 0;
}

export function getVerticalMargins(element: HTMLElement | undefined | null) {
    if (element) {
        const computedStyle = window.getComputedStyle(element);
        const marginTop = parseInt(computedStyle.marginTop, 10);
        const marginBottom = parseInt(computedStyle.marginBottom, 10);
        return marginTop + marginBottom;
    }
    return 0;
}

export function getBottomPadding(element: HTMLElement | undefined | null) {
    if (element) {
        const computedStyle = window.getComputedStyle(element);
        return parseInt(computedStyle.paddingBottom, 10);
    }
    return 0;
}

export function getGap(element: HTMLElement | undefined | null) {
    if (element) {
        const computedStyle = window.getComputedStyle(element);
        const result = parseInt(computedStyle.gap, 10);
        return isNaN(result) ? 0 : result;
    }
    return 0;
}

export function getDistanceFromTop(element: HTMLElement | undefined | null) {
    if (element) {
        return element.offsetTop;
    }
    return 0;
}
